module.exports = __webpack_public_path__ + "static/media/modern-layout-video.bbdecc8f.jpg";